export default "/images/vendor/flag-icon-css/flags/1x1/gq.svg?89421f59da9e40d8cfccac2479092421";